<template>
  <GModal name="modal" class="modal modal-confirm-cart">
    <div slot="header">
      <div class="modal-title">
        <div class="text-red">CANCEL ORDER?</div>
        <div class="text">
          Kamu sudah menambahkan {{ totalQty }} product ke dalam shopping bag. Yakin ingin membatalkannya?
        </div>
      </div>
      <!-- <button type="button" class="close" @click.prevent="close"></button> -->
    </div>
    <div slot="body">
      <div class="continue-shopping" @click="goToOrder">
        <span>CONTINUE SHOPPING</span>
      </div>
      <div class="cancel" @click="cancel">
        <span>YES, CANCEL</span>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'ModalConfirmCart',
  props: {
    totalQty: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    goToOrder() {
      this.$router.push('/vmcola/order/login');
    },
    cancel() {
      this.$emit('close');
    },
  },
};
</script>
